import React from "react";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import "./index.css";

function TestimonialsGetStarted() {
    return (
        <div className="testimonials_getstarted">
            <Container>
                <div className="testimonials_getstarted_block">
                    <h2 className="testimonials_getstarted_block_heading">
                        Get Started Today
                    </h2>
                    <p className="testimonials_getstarted_block_description">
                        Find a licensed professional near you, or start your application now!
                    </p>
                    <Button
                        className="testimonials_getstarted_block_button"
                        href="https://www.swmc.com/ApplyNow/?c=evolution" target="_blank"
                        rel="noopener noreferrer"
                        variant="warning"
                    >
                        Apply Now
                    </Button>
                </div>
            </Container>
        </div>
    );
}

export default TestimonialsGetStarted;